import { Typography } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Form } from "formik";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import CustomDialog from "../../../commons/dialog/customDialog";
import FormikActions from "../../../commons/formik/formikActions";
import FormikAutocomplete from "../../../commons/formik/formikAutocomplete";
import FormikForm from "../../../commons/formik/formikForm";
import FormikTextField from "../../../commons/formik/formikTextField";
import CircularLoading from "../../../commons/loadingData/circularLoading";
import { StyledAddProfessional } from "../../../styled/professional";

const validation = () =>
  Yup.object({
    profesionalApellidoNombre: Yup.string()
      .required("Campo obligatorio")
      .nullable(),
    matricula: Yup.string().required("Campo obligatorio"),
    especialidad: Yup.string().required("Campo obligatorio").nullable(),
  });

const AddProfessional = ({
  open,
  handleSubmit,
  especialidadesProfesional,
  professionalModel,
  handleCancel,
  edit,
  errorProfessionalsDuplicated,
}) => {
  const professionals = useSelector((state) => state.forms.professionals);

  return (
    <CustomDialog
      open={open}
      onClose={handleCancel}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        {!edit ? "Agregar Profesional" : "Editar Profesional"}
      </DialogTitle>
      {professionals.isFetching || especialidadesProfesional.length === 0 ? (
        <StyledAddProfessional.LoadingContainer>
          <CircularLoading />
        </StyledAddProfessional.LoadingContainer>
      ) : (
        <FormikForm
          initialValues={professionalModel}
          validationSchema={() => validation()}
          onSubmit={(values) => handleSubmit(values)}>
          {() => (
            <Form>

              <DialogContent>
                <StyledAddProfessional.RowContainer>
                  <FormikTextField
                    name="profesionalApellidoNombre"
                    label="Profesional *"
                    type="text"
                    sx={{ marginRight: 2 }}
                    disabled={edit}
                  />
                  <FormikTextField
                    name="matricula"
                    label="Matrícula *"
                    type="text"
                    sx={{ marginRight: 2 }}
                  />
                </StyledAddProfessional.RowContainer>
                <StyledAddProfessional.RowContainer>
                  <FormikAutocomplete
                    name="especialidad"
                    label="Especialidad *"
                    options={especialidadesProfesional}
                    sx={StyledAddProfessional.input}
                  />
                </StyledAddProfessional.RowContainer>
                {errorProfessionalsDuplicated && (
                  <Typography color="error">
                    Ya existe un profesional con este nombre.
                  </Typography>
                )}
              </DialogContent>
              <DialogActions>
                <FormikActions handleCancel={handleCancel} />
              </DialogActions>
            </Form>
          )}
        </FormikForm>
      )}
    </CustomDialog>
  );
};

export default AddProfessional;
